// extracted by mini-css-extract-plugin
module.exports = {"artistName":"App_artistName__24CY1","primaryLink":"App_primaryLink__R1u7s","menuLine":"App_menuLine__2zUc9","footer":"App_footer__136r8","linkFooter":"App_linkFooter__-vPbd"};